import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonMaterialModule } from '@nrwl/common-material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonLibModule } from '@nrwl/common-lib';
import { BreadcrumbActionsTimepickerModule } from '@nrwl/breadcrumb-actions-timepicker';
import { NgxPrintModule } from 'ngx-print';

import { FinalTestReportsComponent } from './final.test.report/final.test.reports.component';
// eslint-disable-next-line max-len
import { TruespeedReportsComponent } from './final.test.report/reports/truespeed.reports/components/truespeed.reports/truespeed.reports.component';
import { VoipReportsComponent } from './final.test.report/reports/voip.reports/components/voip.reports/voip.reports.component';
import { TrendingChartComponent } from './final.test.report/reports/trending.chart/trending.chart.component';
import { ReportViewTableComponent } from './final.test.report/reports/report.view.table/report.view.table.component';
import { Y1564ReportsComponent } from './final.test.report/reports/y1564/y1564.reports.component';
import { PerformanceStreamComparisonsComponent } from './final.test.report/reports/performance-stream-comparisons/performance-stream-comparisons.component';
import { TwampReportsComponent } from './final.test.report/reports/twamp/twamp.reports.component';
import { SingleValueChartModule } from '@nrwl/single-value-chart';
import { Rfc2544ReportsComponent } from './final.test.report/reports/rfc2544.reports/rfc2544.reports.component';
import { UdpFinalComponent } from './final.test.report/reports/udp-final-reports/udp-final/udp-final.component';
import { HttpFinalReportsComponent } from './final.test.report/reports/http/components/http-final-reports.component';
import { BertReportsComponent } from './final.test.report/reports/bert-reports/bert-reports.component';
import { FtpFinalReportsComponent } from './final.test.report/reports/ftp/components/ftp-final-reports.component';
@NgModule({
  declarations: [
    FinalTestReportsComponent,
    TruespeedReportsComponent,
    VoipReportsComponent,
    TrendingChartComponent,
    ReportViewTableComponent,
    Y1564ReportsComponent,
    PerformanceStreamComparisonsComponent,
    TwampReportsComponent,
    Rfc2544ReportsComponent,
    UdpFinalComponent,
    HttpFinalReportsComponent,
    BertReportsComponent,
    FtpFinalReportsComponent
  ],
  imports: [
    NgxPrintModule,
    CommonModule,
    CommonMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SingleValueChartModule,
    CommonLibModule,
    BreadcrumbActionsTimepickerModule
  ],
  exports: [TrendingChartComponent]
})
export class FinalTestReportsModule {}
